import {
  Action,
  Container,
  Heading1,
  Icon,
  ModalWrapper,
  OrderedList,
  Paragraph,
  YoutubeVideo,
} from "shared/components";
import { useToggle } from "shared/hooks";
import { parseYouTubeId } from "shared/utils";

import styles from "./Hero016.module.scss";

export const Hero016 = ({ payload }) => {
  const headline = payload?.headline ?? "";
  const facts = payload?.facts ?? [];
  const { videoLink } = payload?.video ?? null;
  const { buttonText } = payload?.video ?? "";

  const videoId = parseYouTubeId(videoLink);

  const { opened, onOpen, onClose } = useToggle();

  return (
    <div className={styles.wrapper}>
      <Container>
        <Heading1 className={styles.title} color="dark">
          {headline}
        </Heading1>
        <div className={styles.content}>
          {videoId && (
            <Action onClick={onOpen} className={styles.play}>
              <span className={styles.arrow}>
                <Icon className={styles.icon} name="arrow_right" />
              </span>
              <Paragraph color="brand" appearance="bigger">
                {buttonText}
              </Paragraph>
            </Action>
          )}
          {opened && (
            <ModalWrapper onCloseModal={onClose} appearance="full-area">
              <YoutubeVideo id={videoId} />
            </ModalWrapper>
          )}
          <OrderedList
            items={facts}
            appearance="bigger"
            className={styles.facts}
          />
        </div>
      </Container>
    </div>
  );
};

export default Hero016;
